module.exports = __webpack_public_path__ + "static/media/portfolio.83d7edbe.jpg";